import { NgModule } from '@angular/core';

import { ImageViewerComponent } from './image-viewer.component';
import { ImageViewerService }   from './image-viewer.service';

@NgModule({
  declarations: [
    ImageViewerComponent
  ],
  entryComponents: [
    ImageViewerComponent
  ],
  exports: [
    ImageViewerComponent
  ],
  providers: [
    ImageViewerService
  ]
})
export class ImageViewModule {}
